// extracted by mini-css-extract-plugin
export default {"root":"Auth_root__nIdeL","title":"Auth_title__MfTGo","field":"Auth_field__rgh8D"};